import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { NavigationBarService } from '../../shared/navigation-bar.service';
import { RightSideService } from '../../shared/right-side.service';
import { PageContent } from '../../shared/classes/page-content.model';
import { storageFactory } from '../../../../app-storage';

@Component({
  selector: 'app-navigation-tabs',
  templateUrl: './navigation-tabs.component.html',
  styleUrls: ['./navigation-tabs.component.css']
})
export class NavigationTabsComponent implements OnInit {
  steps: Array<any> = [];
  selectedTab: number;
  @ViewChild('navHeader') navHeader : ElementRef;
  toggleHowToProcess: boolean
  activeNumberColor: string;
  passiveNumberColor: string;
  activeBackgroundColor: string;
  passiveackgroundColor: string;
  completedBackgroundColor: string;
  isIOS: boolean;
  isCashbackEnabled = false;
  stepStartIndex = 0;
  pageContent: PageContent;
  constructor(private navBarService: NavigationBarService,
  private tabsService: RightSideService) {
    this.selectedTab = this.navBarService.getSelectedTab();
    this.navBarService.selectedTabChange.subscribe(tab => {
      this.selectedTab = this.navBarService.getSelectedTab();
    });

    this.tabsService.cashbackEnabledChange.subscribe(val => {
      const isEnabled = this.tabsService.getCashbackEnabled();
      this.isCashbackEnabled = isEnabled;
      this.stepStartIndex = isEnabled ? 1 : 0;
    });

    this.tabsService.pageContentChange.subscribe(val => {
      this.pageContent = this.tabsService.getPageContent();
    });
    this.activeNumberColor = '#ffffff';
    this.passiveNumberColor = '#7b7b7b';
    this.toggleHowToProcess = false;
    this.activeBackgroundColor = '#6c84fa';
    this.passiveackgroundColor = '#eeeeee';
    this.completedBackgroundColor = '#5163bb';
    this.isIOS = (storageFactory(localStorage).getItem('isIOS') === 'true');
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/buyback-form/main-section/header/navigation-tabs/navigation-tabs.component.ts